import React, { forwardRef, useEffect, useImperativeHandle, useMemo, useState } from 'react';
import { Dropdown } from '@nackle/paper';
import './styles.less';
import { getString } from '@nackle/intl-tools';
import { Navigation, Routes } from '../../navigation';
import classNames from 'classnames';
import { Translate } from '../../services/translationService/components/Translate';
import { Spin } from 'antd';
import CaretIcon from '../common/caretIcon';
import { onResizeEffect } from '../../scripts/utils';


export const CategoryDropdown = forwardRef( ( { data, brand, loading, onOpenCb }, ref ) => {
    
    
    useImperativeHandle( ref, () => ( {
        close: () => {
            close();
        }
    } ), [] );

    const [ open, setOpen ] = useState( false );

    function close() {
        setOpen( false );
    }

    function handleClick( id ) {
        close();
        Navigation.push( Routes.CategoryDetails.buildPath( id ) );
    }

    useEffect( onResizeEffect( close ), [] );

    const items = useMemo( () => loading ? [ {
        key: 'loading',
        className: 'loading',
        label: <Spin />
    } ] : data == null || data.length == 0 ? [ {
        key: 'nodata',
        label: getString( 'categoryList.noData' )
    } ] : data.map( c => ( {
        key: c.id,
        className: 'clickable _subtitle',
        label: <span onClick={ () => handleClick( c.id ) }>{ c.name }</span>
    } ) ), [ loading, data ] );

    function toggleOpen() {
        const newOpenState = !open;
        setOpen( newOpenState );
        if ( newOpenState == true ) {
            onOpenCb?.();
        }
    }

    return <Dropdown 
        open={ open }
        menu={ { items } }
        overlayClassName={ classNames( 'dropdown', 'category-dropdown', 'header-dropdown', brand, { isOpen: open, isClosed: !open } ) }
    >
        <a onClick={ toggleOpen } >
            <Translate.Text value="header.nav.categories" />
            <CaretIcon direction={ open ? 'down' : 'right' } />
        </a>
    </Dropdown>;

} );